/**************************************************
 * Nombre:       Formulario_Espacio_Blog
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {Flag, SchoolOutlined, ShortTextOutlined} from "@mui/icons-material";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSPRODUCTO} from "../../../Constantes";
import IngresoImagenCrop from "../../../Modulo_formularios/Componentes/IngresoImagenCrop";
import IngresoFecha from "../../../Modulo_formularios/Componentes/IngresoFecha";
import IngresoHora from "../../../Modulo_formularios/Componentes/IngresoHora";

const Formulario_Espacio_Blog = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 14}}>**Imagen Blog Home de 1600px por 760px de menos de 500K de
                        peso</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagenCrop dato={'imgDos'} alto={760} ancho={1600} {...props}  />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={4} nombre={'Frase Destacada'}
                                  dato={'frase'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>



                <Grid container size={12}>
                    <IngresoTexto nombre={'Link Blog'}
                                  dato={'linkBlog'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Espacio_Blog